import 'core-js/modules/es.object.keys';
import { assertType, assertRange } from 'yaassertion';

var Cldr = require('cldrjs/dist/cldr');
var countryAliasMapping = {
  C2: "CN",
  UK: "GB"
};
function getResolvedRegion(region) {
  return countryAliasMapping[region] || region;
}
var getMissingMetadataError = function getMissingMetadataError(path) {
  var message = "Missing WorldReady metadata, please refer to https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data.html";
  if (path) {
    message += "\nPath: " + path;
  }
  return new Error(message);
};
function validateCldr(path, value, options) {
  if (options === void 0) {
    options = {
      skip: []
    };
  }
  var skipBoolean = options.skip.some(function (regex) {
    return regex.test(path);
  });
  if (skipBoolean) {
    return;
  }
  if (value === undefined) {
    throw getMissingMetadataError(path);
  }
}

/**
 * ExampleGenerator(options)
 */
var ExampleGenerator = /*#__PURE__*/function () {
  function ExampleGenerator(options) {
    if (options === void 0) {
      options = {};
    }
    if (process.env.NODE_ENV !== "production") {
      assertType(options, "options", ["undefined", "plain object"]);
      assertType(options.feature, "options.feature", ["string"]);
      assertRange(options.feature, ["phone"], "options.feature must be 'phone'");
      if (options.feature === "phone") {
        var cldr = new Cldr("und");
        cldr.on("get", validateCldr);
        var phoneTypes;
        try {
          phoneTypes = cldr.get(["supplemental/example/phoneData/phoneTypes"]);
        } finally {
          cldr.off("get", validateCldr);
        }
        assertRange(options.type, Object.keys(phoneTypes), "Invalid value for phone number type: {type}", {
          type: options.type
        });
      }
    }
    var region = options.region;
    if (region) {
      region = getResolvedRegion(region);
    }
    switch (options.feature) {
      case "phone":
        this.get = function () {
          var cldr = new Cldr("und");
          cldr.on("get", validateCldr);
          var nationalNumbers, phoneTypes, countryCodes;
          try {
            nationalNumbers = cldr.get(["supplemental/example/phoneData/nationalNumbers/" + region]);
            phoneTypes = cldr.get(["supplemental/example/phoneData/phoneTypes"]);
            countryCodes = cldr.get("supplemental/phoneData/callingCode");
          } finally {
            cldr.off("get", validateCldr);
          }
          var nationalNumber = nationalNumbers[phoneTypes[options.type]];
          if (!nationalNumber)
            // return same data type that fullstackphone does
            return null;
          return {
            nationalNumber: nationalNumber,
            countryCode: countryCodes[region]
          };
        };
        break;
    }
  }
  var _proto = ExampleGenerator.prototype;
  _proto.generate = function generate() {
    return this.get();
  };
  return ExampleGenerator;
}();

export { ExampleGenerator };
